import { Controller } from "stimulus";

// Renders a FullCalendar (loaded globally via CDN) of the current user's checklist
// items, positioned by their due date. Events are passed in from the server as a
// data-value array. Clicking an event opens its ticket in the sliding right-hand
// detail drawer — same as the dashboard preview rows: we drive the `ticket_detail`
// turbo-frame, whose fetch event bubbles up to the detail-drawer controller.
export default class extends Controller {
  static targets = ["calendar"];
  static values = { events: Array, frame: { type: String, default: "ticket_detail" } };

  connect() {
    if (!this.hasCalendarTarget || typeof FullCalendar === "undefined") return;

    this.calendar = new FullCalendar.Calendar(this.calendarTarget, {
      initialView: "dayGridMonth",
      locale: "pt-br",
      height: "auto",
      headerToolbar: { left: "prev,next today", center: "title", right: "" },
      buttonText: { today: "Hoje" },
      events: this.eventsValue,
      eventClick: this.openInDrawer.bind(this),
    });
    this.calendar.render();
  }

  disconnect() {
    if (this.calendar) this.calendar.destroy();
  }

  // Open the ticket in the right drawer instead of navigating the whole page.
  openInDrawer(info) {
    if (info.jsEvent) info.jsEvent.preventDefault();

    const url = info.event.url;
    const frame = document.getElementById(this.frameValue);
    if (!url || !frame) return;

    frame.src = url;
  }
}
